import {
    useMutation,
    useQueryClient,
    UseMutationResult,
} from '@tanstack/react-query'
import { addRelation } from '../../../../services/dtServices'
import { IRelation } from '../../interfaces'

export const useCreateRelation = (
    entityTemplateId: string,
    orgId: string,
): UseMutationResult<
    Awaited<ReturnType<typeof addRelation>>,
    Error,
    IRelation
> => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (relation: IRelation) => {
            return addRelation(entityTemplateId, orgId, relation)
        },
        //client side optimistic update
        onMutate: (newRelationInfo: IRelation) => {
            queryClient.setQueryData(
                ['relations', entityTemplateId, orgId],
                (relations: IRelation[]) =>
                    [
                        ...relations,
                        {
                            ...newRelationInfo,
                            id: (Math.random() + 1).toString(36).substring(7),
                        },
                    ] as IRelation[],
            )
        },
        onSettled: () =>
            queryClient.invalidateQueries({
                queryKey: ['relations', entityTemplateId],
            }),
    })
}
